module.exports = __webpack_public_path__ + "images/fa-fw-bg-footer-mobile-final.webp";